import React from "react";

interface ContractTypeBadgeProps {
  contractType: "CDI" | "CDD" | "Stage" | "Other" | string;
  text?: string;
  className?: string;
  size?: "sm" | "mid" | "lg";
}

const CONTRACT_COLORS: Record<string, "success" | "warning" | "primary" | "info" | "secondary"> = {
  CDI: "success",    
  CDD: "warning",     
  Stage: "primary", 
  Other: "info",     
};

const CONTRACT_ICONS: Record<string, string> = {
  CDI: "ti ti-file-text",         
  CDD: "ti ti-calendar-time",    
  Stage: "ti ti-school",          
  Other: "ti ti-file-unknown",      
};

const CONTRACT_LABELS: Record<string, string> = {
  CDI: "CDI",
  CDD: "CDD", 
  Stage: "Stage",
  Other: "Other",
};

const ContractTypeBadge: React.FC<ContractTypeBadgeProps> = ({ 
  contractType,
  text,
  className = "",
  size = "mid"
}) => {
  const sizeStyles = {
    sm: { fontSize: '0.75rem', iconSize: '1rem', padding: 'px-2 py-1' },
    mid: { fontSize: '0.875rem', iconSize: '1.2rem', padding: 'px-3 py-1' },
    lg: { fontSize: '1rem', iconSize: '1.5rem', padding: 'px-4 py-2' },
  }[size];

  const badgeColor = CONTRACT_COLORS[contractType] || "secondary";
  const badgeIcon = CONTRACT_ICONS[contractType] || "ti ti-file";
  const displayText = text || CONTRACT_LABELS[contractType] || contractType;

  return (
    <span 
      className={`badge badge-soft-${badgeColor} d-inline-flex align-items-center ${sizeStyles.padding} ${className}`}
      style={{ fontSize: sizeStyles.fontSize }}
    >
      <i 
        className={`${badgeIcon} me-1`} 
        style={{ fontSize: sizeStyles.iconSize }}
      ></i>
      {displayText}
    </span>
  );
};

export default ContractTypeBadge;